// Public founding-cohort member card — cast-style, real members.
import { ExternalLink } from "lucide-react";

export const MemberCard = ({ m }) => {
  const img = m.headshot_url || m.avatar_url;
  const skills = Array.isArray(m.skills) ? m.skills : m.skills ? String(m.skills).split(",").map((s) => s.trim()).filter(Boolean).slice(0, 6) : [];
  return (
    <div className="group overflow-hidden gold-frame bg-charcoal transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_35px_rgba(201,162,39,0.18)]" data-testid={`member-card-${m.member_number || "fc"}`}>
      <div className="panel-mono relative h-64 overflow-hidden">
        {img ? (
          <img src={img} alt={m.name} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-onyx">
            <span className="flex h-28 w-28 items-center justify-center rounded-full border border-gold/50 font-display text-6xl text-gold-metallic">
              {(m.name || "V")[0].toUpperCase()}
            </span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-onyx/70 to-transparent" />
        <span className="absolute left-2 top-2 border border-gold/50 bg-onyx/85 px-2 py-0.5 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-gold">
          {m.member_number || "Founding Member"}
        </span>
        <span className="absolute bottom-2 right-2 border border-silver/40 bg-onyx/85 px-2 py-0.5 font-mono text-[8px] uppercase tracking-[0.2em] text-silver/80">
          Founding Cohort {m.cohort_year}
        </span>
      </div>
      <div className="border-t border-gold/25 p-4">
        <h3 className="font-display text-2xl uppercase leading-none tracking-tight text-cream">{m.name}</h3>
        <p className="mt-1 font-mono text-[10px] uppercase tracking-widest text-gold">{m.lane || "Creative Cohort Member"}{m.city_state ? ` · ${m.city_state}` : ""}</p>
        {m.bio && <p className="mt-2 font-body text-sm leading-relaxed text-silver/75 line-clamp-3">{m.bio}</p>}
        {skills.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1.5">
            {skills.map((s) => (
              <span key={s} className="border border-silver/25 px-1.5 py-0.5 font-mono text-[9px] uppercase tracking-wide text-silver/70">{s}</span>
            ))}
          </div>
        )}
        {m.portfolio_url && (
          <a href={m.portfolio_url} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1.5 font-head text-[11px] font-extrabold uppercase tracking-[0.15em] text-goldlight transition-colors hover:text-gold">
            Portfolio <ExternalLink size={11} />
          </a>
        )}
      </div>
    </div>
  );
};
